/* Houdt het gekozen formaat vast als de klant naar een andere kleur klikt.

   Elke link draagt een data-sizes mee met { namen: { formaat: variant-id }, volgorde: [ids] }.
   De optienaam en de optiewaarden worden per taal vertaald en niet overal even consequent,
   dus zoeken we eerst op de tekst van het gekozen formaat en anders op het volgnummer. */

if (!customElements.get('product-kleurvarianten')) {
  customElements.define(
    'product-kleurvarianten',
    class ProductKleurvarianten extends HTMLElement {
      connectedCallback() {
        this.showNameOnHover();

        if (this.dataset.keepSize === 'false') return;

        this.optionName = this.dataset.sizeOption || 'Formaat';
        this.links = Array.from(this.querySelectorAll('a[data-sizes]'));
        if (this.links.length === 0) return;

        this.baseUrls = this.links.map((link) => link.getAttribute('href').split('?')[0]);
        this.sizeMaps = this.links.map((link) => {
          try {
            return JSON.parse(link.dataset.sizes);
          } catch (error) {
            return { namen: {}, volgorde: [] };
          }
        });

        this.container = this.closest('product-info') || this.closest('section') || document;
        this.onChange = this.updateLinks.bind(this);
        this.container.addEventListener('change', this.onChange);

        this.updateLinks();
      }

      // Het label boven de rij loopt mee met het bolletje waar de klant op staat,
      // en valt terug op de kleur van dit product.
      showNameOnHover() {
        const value = this.querySelector('.kleurvarianten__value');
        if (!value) return;

        const eigenKleur = this.dataset.currentKleur || value.textContent;

        this.querySelectorAll('a[data-kleur]').forEach((link) => {
          const toon = () => {
            value.textContent = link.dataset.kleur;
          };
          const herstel = () => {
            value.textContent = eigenKleur;
          };

          link.addEventListener('mouseenter', toon);
          link.addEventListener('focus', toon);
          link.addEventListener('mouseleave', herstel);
          link.addEventListener('blur', herstel);
        });
      }

      disconnectedCallback() {
        if (this.container && this.onChange) {
          this.container.removeEventListener('change', this.onChange);
        }
      }

      optionGroups() {
        return Array.from(
          this.container.querySelectorAll('variant-selects .product-form__input, .product-form__input')
        ).filter((group) => group.querySelector('input[type="radio"], select'));
      }

      sizeGroup() {
        const groups = this.optionGroups();

        // Eerst op naam: die staat in de legend of het label van de groep.
        for (const group of groups) {
          const label = group.querySelector('legend, .form__label');
          if (label && label.textContent.trim().startsWith(this.optionName)) return group;
        }

        // De optienaam wordt vertaald, dus anders op positie.
        const position = parseInt(this.dataset.sizePosition, 10) || 1;
        return groups[position - 1] || null;
      }

      selection() {
        const fallback = {
          value: this.dataset.currentSize || '',
          number: parseInt(this.dataset.currentNumber, 10) || 0,
        };

        const group = this.sizeGroup();
        if (!group) return fallback;

        // Knoppen of pills
        const inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
        const checked = inputs.find((input) => input.checked);
        if (checked) return { value: checked.value, number: inputs.indexOf(checked) };

        // Uitklaplijst
        const select = group.querySelector('select');
        if (select) return { value: select.value, number: select.selectedIndex };

        return fallback;
      }

      updateLinks() {
        const { value, number } = this.selection();

        this.links.forEach((link, index) => {
          const map = this.sizeMaps[index] || {};
          const namen = map.namen || {};
          const volgorde = map.volgorde || [];
          const variantId = namen[value] || volgorde[number];

          link.setAttribute(
            'href',
            variantId ? `${this.baseUrls[index]}?variant=${variantId}` : this.baseUrls[index]
          );
        });
      }
    }
  );
}
